const base = "api.arkaj.shop"
// const base = "192.168.10.25:8001"
const https = true
export const baseUrl = `http${https ? 's':''}://${base}`;




